import { render, staticRenderFns } from "./SuperIntendenciaMilton.vue?vue&type=template&id=840162c8&scoped=true"
import script from "./SuperIntendenciaMilton.vue?vue&type=script&lang=js"
export * from "./SuperIntendenciaMilton.vue?vue&type=script&lang=js"
import style0 from "./SuperIntendenciaMilton.vue?vue&type=style&index=0&id=840162c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840162c8",
  null
  
)

export default component.exports